module.exports = __webpack_public_path__ + "static/img/0.5a38b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/0.png
// module id = FisX
// module chunks = 0